import { Store } from 'redux';
import { getStore } from '../Redux/store.provider';
import { saveOrder } from './formModel.service';
import { dialogueError, setSavingState } from '../Redux/Actions';
import { FormBaseStore } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { ResponseError } from 'sos-common/js/utils/ResponseError';
import {
  getErrorBodyApiErrorOnSave,
  getErrorBodyJwtTokenTimeout,
  getErrorBodyVipSPSessionTimeout,
} from 'sos-eservice-common/js/config';

let _store: Store<FormBaseStore<any>>;
let isStarted = false;
export function setupAutoSave() {
  if (!isStarted) {
    getStore((store) => {
      _store = store;
      startWork();
    });
  }
}

let token: any;
function startWork() {
  token = setInterval(autoSave, 5000);
  isStarted = true;
}

let prevForm: any;
function autoSave() {
  const currentStoreState = _store.getState();
  const orderId = currentStoreState.globals.orderId;
  const currentForm = currentStoreState.formModel;
  const { globals } = currentStoreState;
  const { dispatch } = _store;

  if (prevForm === currentForm) {
    dispatch(setSavingState(false));
    return;
  }

  prevForm = currentForm;
  dispatch(setSavingState(true));
  saveOrder(currentForm, orderId)
    .then((result) => {
      if (result instanceof ResponseError) {
        const error = result as ResponseError;
        if (error.body.detailCode) {
          switch (error.body.detailCode) {
            case '401.1':
              // VIP (SP) SESSION TIMED OUT
              dispatch(dialogueError(getErrorBodyVipSPSessionTimeout(error.body.redirectUri)));
              break;
            case '401.2':
              // JWT TOKEN TIMED OUT
              dispatch(dialogueError(getErrorBodyJwtTokenTimeout(error.body.redirectUri)));
              break;
          }
        } else {
          switch (error.statusCode) {
            case 400:
              // API error
              dispatch(
                dialogueError(
                  getErrorBodyApiErrorOnSave(currentStoreState.globals.homePageUrl, error.body.errorMessage)
                )
              );
              break;
            default:
              dispatch(
                dialogueError(
                  getErrorBodyApiErrorOnSave(currentStoreState.globals.homePageUrl, error.body.errorMessage)
                )
              );
          }
        }
      }
    })
    .finally(() => {
      dispatch(setSavingState(false));
    });
}
